import { createSlice } from "@reduxjs/toolkit";
import { FeatureFlagAvailability } from "@/central-atoms/feature-flags/types";

// Define the state type
type FeatureFlagsState = {
  featureFlags: Record<string, FeatureFlagAvailability>;
  loading: boolean;
  error: string | null;
};

// Initial state
const initialState: FeatureFlagsState = {
  featureFlags: {},
  loading: false,
  error: null
};

// Create the slice and export actions
const slice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setFeatureFlags: (state, action) => {
      state.featureFlags = action.payload;
      state.loading = false;
      state.error = null;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setLoading: (state) => {
      state.loading = true;
    }
  }
});

// Export actions
export const { setFeatureFlags, setError, setLoading } = slice.actions;

// Export the reducer
export default slice.reducer; 